var _path, _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointingStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 123,
    viewBox: "0 0 16 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31805 2.14389C9.31805 1.16534 8.52478 0.37207 7.54623 0.37207C6.56768 0.37207 5.77441 1.16534 5.77441 2.14389V3.06662C5.77441 4.55331 4.56921 5.75851 3.08252 5.75851H2.16244C1.1839 5.75851 0.390625 6.55178 0.390625 7.53033C0.390625 8.50888 1.1839 9.30215 2.16244 9.30215H3.08252C4.56921 9.30215 5.77441 10.5074 5.77441 11.994V12.9167C5.77441 13.8952 6.56768 14.6885 7.54623 14.6885C8.52478 14.6885 9.31805 13.8952 9.31805 12.9167V11.9953C9.31805 10.5079 10.5238 9.30215 12.0112 9.30215H12.9352C13.9138 9.30215 14.707 8.50888 14.707 7.53033C14.707 6.55178 13.9138 5.75851 12.9352 5.75851H12.0113C10.5238 5.75851 9.31805 4.55272 9.31805 3.06529V2.14389Z",
    fill: "#F69A4D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.89062,
    y1: 18.3721,
    x2: 7.89062,
    y2: 70.3721,
    stroke: "url(#paint0_linear_2644_7092)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2644_7092",
    x1: 6.39047,
    y1: 19.6672,
    x2: 6.39047,
    y2: 71.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointingStyle);
export default __webpack_public_path__ + "static/media/pointing-style.fcaeaf9e3380909ed873407c103e446e.svg";
export { ForwardRef as ReactComponent };